import { makeStyles, Theme } from "@material-ui/core/styles";

const styles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: '100%',
  },
  typography: {
    padding: theme.spacing(0),
  },
  profileOptionsHeader: {
    width: '100%',
    maxWidth: 460,
    minWidth: 360,
    backgroundColor: theme.palette.gray5.main,
  },
  profileOptionsBody: {
    width: '100%',
    maxWidth: 460,
    minWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  textStyle: {
    fontSize: 12,
  },
  profileHeaderAvatar: {
    fontSize: 50,
    color: theme.palette.primary.main,
    backgroundColor: 'white',
  },
  THbadge: {
    backgroundColor: '#44b700',
    color: '#44b700',
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      animation: '$ripple 1.2s infinite ease-in-out',
      border: '1px solid currentColor',
      content: '""',
    },
  },
  BKbadge: {
    backgroundColor: theme.palette.brandBKColors.main,
    color: '#44b700',
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      animation: '$ripple 1.2s infinite ease-in-out',
      border: '1px solid currentColor',
      content: '""',
    },
  },
  PLKbadge: {
    backgroundColor: '#44b700',
    color: '#44b700',
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      animation: '$ripple 1.2s infinite ease-in-out',
      border: '1px solid currentColor',
      content: '""',
    },
  },
  brandBKAvatarColors: {
    backgroundColor: theme.palette.brandBKColors.main,
    color: theme.palette.brandBKColors.dark,
    fontSize: 40,
  },
  brandPLKAvatarColors: {
    backgroundColor: theme.palette.brandPLKColors.main,
    color: theme.palette.white.main,
    fontSize: 40,
  },
  brandTHColors: {
    backgroundColor: theme.palette.brandTHColors.main,
    color: theme.palette.brandTHColors.dark,
    fontSize: 40,
  },
  brandDefaultAvatarColors: {
    backgroundColor: '#ffffff',
    color: '#ffffff',
    fontSize: 40,
  },
}));

export default styles;
